const baseStyle = {}

const defaultProps = {
  size: 'md',
}

const parts = ['stepVertical']

const sizes = {
  sm: {},
  md: {},
}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
